// GRNDatosTabXL - Sprint 44 Fase 3 Vista 9.
// Tab "Datos basicos" del GRN form. Extraido para respetar regla 300L.
import POPickerXL from '../po_xl/POPickerXL';
import XLInput from '../../components/xl/XLInput';
import XLSelect from '../../components/xl/XLSelect';

const ESTADO_OPTIONS = [
  { value: 'borrador', label: 'Borrador' },
  { value: 'recibido_parcial', label: 'Recibido parcial' },
  { value: 'recibido_total', label: 'Recibido total' },
];

export default function GRNDatosTabXL({ form, set, isEdit }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '16px' }}>
      {!isEdit && (
        <div style={{ gridColumn: '1 / -1' }}>
          <label
            style={{
              fontSize: '12px', fontWeight: 500,
              color: 'var(--xl-color-text-secondary)',
              display: 'block', marginBottom: '4px',
            }}>
            Purchase Order *
          </label>
          <POPickerXL onSelectPO={(po) => {
            set('po_id', po.id);
            set('po_referencia', po.referencia);
            set('proveedor_nombre', po.proveedor_nombre);
          }} />
          {form.po_referencia && (
            <p style={{
              fontSize: '11px', color: 'var(--xl-color-success)',
              marginTop: '4px',
            }}>
              {'\u2713'} PO seleccionada: {form.po_referencia}
            </p>
          )}
        </div>
      )}

      <XLInput label="Referencia" value={form.referencia}
        onChange={(e) => set('referencia', e.target.value)}
        placeholder="auto si se deja vacio" />

      <XLInput label="Fecha recepcion *" type="date"
        value={form.fecha_recepcion}
        onChange={(e) => set('fecha_recepcion', e.target.value)} />

      {isEdit && (
        <XLSelect label="Estado" value={form.estado}
          onChange={(e) => set('estado', e.target.value)}
          options={ESTADO_OPTIONS} />
      )}

      <div style={{ gridColumn: '1 / -1' }}>
        <label
          style={{
            fontSize: '12px', fontWeight: 500,
            color: 'var(--xl-color-text-secondary)',
            display: 'block', marginBottom: '4px',
          }}>
          Observaciones
        </label>
        <textarea
          rows={3} value={form.observaciones}
          onChange={(e) => set('observaciones', e.target.value)}
          style={{
            width: '100%', minHeight: '80px', resize: 'vertical',
            font: '400 14px/1.5 var(--xl-font-sans)',
            color: 'var(--xl-color-text)',
            background: 'var(--xl-color-bg)',
            border: '1px solid var(--xl-color-border)',
            borderRadius: 'var(--xl-radius-md)',
            padding: '10px 12px', boxSizing: 'border-box',
          }} />
      </div>
    </div>
  );
}
